import { toast } from "react-toastify";
import Campo from "../Shared/Campo";

const DIA_VISITA_LABELS = {
    SEGUNDA_FEIRA: "Segunda-feira",
    TERCA_FEIRA: "Terça-feira",
    QUARTA_FEIRA: "Quarta-feira",
    QUINTA_FEIRA: "Quinta-feira",
    SEXTA_FEIRA: "Sexta-feira",
    SABADO: "Sábado",
};

// Separa "lat,lng" em duas partes. Retorna null se o formato não for exatamente
// dois números válidos dentro dos limites geográficos (aí exibe o valor original).
function separarCoordenadas(valor) {
    if (typeof valor !== "string") return null;
    const partes = valor.split(",").map((p) => p.trim());
    if (partes.length !== 2) return null;
    const numero = /^-?\d+(\.\d+)?$/;
    if (!partes.every((p) => numero.test(p))) return null;
    const [lat, lng] = partes;
    if (Math.abs(Number(lat)) > 90 || Math.abs(Number(lng)) > 180) return null;
    return { lat, lng };
}

// Dados acumulados do processo — sempre visível, independentemente da etapa atual.
export default function DetalheAjusteGtc({ detalheProcesso }) {
    if (!detalheProcesso) return null;
    const d = detalheProcesso;
    const coords = separarCoordenadas(d.coordenadas);

    return (
        <div className="bg-card border border-border rounded-lg shadow-card p-4 md:p-6 flex flex-col gap-4">
            <div>
                <h2 className="font-display text-base font-semibold text-foreground mb-4">Cliente</h2>
                <div className="grid grid-cols-2 md:grid-cols-6 gap-4 text-sm">
                    <Campo label="Código do Cliente" valor={d.clienteCodigo} />
                    <div className="col-span-3">
                        <Campo label="Razão Social" valor={d.razaoSocial} />

                    </div>
                    <div className="col-span-2">
                        <Campo label="Nome Fantasia" valor={d.fantasia} />
                    </div>
                </div>
            </div>

            {d.incluiAlteracaoGtc && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Alteração de GTC</h3>
                    <div className="grid grid-cols-2 md:grid-cols-2 gap-4 text-sm">
                        <Campo label="Subcanal Atual" valor={d.subCanalAtualNome} />
                        <Campo label="Subcanal Proposto" valor={d.subCanalPropostoNome} />
                    </div>
                </div>
            )}

            {d.incluiAlteracaoRota && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Alteração de Rota</h3>
                    <div className="grid grid-cols-2 md:grid-cols-2 gap-4 text-sm">
                        <Campo label="Rota Atual" valor={d.rotaAtual} />
                        <Campo label="Rota Proposta" valor={d.rotaProposta} />
                    </div>
                </div>
            )}

            {d.incluiAlteracaoVisita && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Alteração de Visita</h3>
                    <div className="grid grid-cols-2 md:grid-cols-2 gap-4 text-sm">
                        <Campo label="Dia de Visita Atual" valor={DIA_VISITA_LABELS[d.diaVisitaAtual] || d.diaVisitaAtual} />
                        <Campo label="Dia de Visita Proposto" valor={DIA_VISITA_LABELS[d.diaVisitaProposto] || d.diaVisitaProposto} />
                    </div>
                </div>
            )}

            {d.incluiAtualizacaoCoordenadas && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Atualização de Coordenadas</h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                        {coords ? (
                            <>
                                <Campo label="Latitude" valor={coords.lat} />
                                <Campo label="Longitude" valor={coords.lng} />
                            </>
                        ) : (
                            <Campo label="Coordenadas" valor={d.coordenadas} />
                        )}
                    </div>
                    {d.coordenadas && (
                        <a
                            href={`https://www.google.com/maps?q=${d.coordenadas}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-1.5 text-sm text-primary hover:underline mt-2"
                        >
                            <i className="fa fa-map-marker-alt" /> Abrir no mapa
                        </a>
                    )}
                </div>
            )}

            {d.justificativaSupervisor && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Justificativa da Análise (Supervisor)</h3>
                    <p className="text-sm text-foreground whitespace-pre-wrap">{d.justificativaSupervisor}</p>
                </div>
            )}

            {d.justificativaComercial && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Justificativa da Análise Comercial</h3>
                    <p className="text-sm text-foreground whitespace-pre-wrap">{d.justificativaComercial}</p>
                </div>
            )}

            {(d.confirmacaoAlteracao || d.detalhes) && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Cadastro/Alteração</h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                        <Campo label="Alteração realizada" valor={d.confirmacaoAlteracao ? "Sim" : "Não"} />
                    </div>
                    {d.detalhes && <p className="text-sm text-foreground whitespace-pre-wrap mt-3">{d.detalhes}</p>}
                </div>
            )}
        </div>
    );
}